import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatCurrency, formatPercentage } from '@/utils/formatters';

interface MetricsCardProps {
  title: string;
  value: number;
  trend?: 'up' | 'down';
  type?: 'currency' | 'percentage';
}

export function MetricsCard({ 
  title, 
  value, 
  trend,
  type = 'currency'
}: MetricsCardProps) {
  const formattedValue = type === 'percentage' ? formatPercentage(value) : formatCurrency(value);
  const isPositive = trend === 'up';
  const trendColor = isPositive ? 'text-green-500' : 'text-red-500';

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="text-sm text-muted-foreground">{title}</div>
        <div className="mt-2 flex items-center gap-2">
          <div className="text-2xl font-semibold">
            {formattedValue}
          </div>
          {trend && (
            trend === 'up' ? 
              <TrendingUp className={`h-4 w-4 ${trendColor}`} /> : 
              <TrendingDown className={`h-4 w-4 ${trendColor}`} />
          )}
        </div>
      </CardContent>
    </Card>
  );
}